import { Error404Component } from "@/routes/_error/404";
import { Error500Component } from "@/routes/_error/500";
import { routeTree } from "@/routeTree.gen";

/** Shared options for `createRouter` (client + prerender). */
export function getAppRouterOptions() {
	return {
		routeTree,
		context: {},
		defaultPreload: "intent" as const,
		scrollRestoration: true,
		defaultStructuralSharing: true,
		defaultPreloadStaleTime: 0,
		defaultNotFoundComponent: () => <Error404Component />,
		defaultErrorComponent: () => <Error500Component />,
	};
}
